import _ from 'lodash';
import { apiFetch } from './utility';

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'resource.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, files = [], callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'resource.add',
			listNameToUpdate : 'resourceIds',
			params,
			files,
			dispatch,
			//successMessage : `Resource uploaded successfully`,
			callback,
		});
	};
};
